import React, { Component } from "react"
import { connect } from 'react-redux'

import {msg} from '../../components/Notifications/MsgBox';

class UploadButton extends Component {

    constructor(props) {
        super(props)
        this.state = {
        };
    }

    componentDidMount() {
        
    }

    componentWillReceiveProps(nextProps) {

    }

    openUploadModal() {
        const { modalId,transaction_no,file_category,defaultFileName } = this.props;

        if(transaction_no)
        {
            window.$(`#filename_${file_category}`).val(defaultFileName);
            window.$(`#file_${file_category}`).val('');
            window.$(`#${modalId}`).modal('show');
        }
        else{
            msg.error("กรุณาบันทึกรายการก่อน อัพโหลดไฟล์")
        }

    }

    render() {
        const { modalId,transaction_no,viewMode } = this.props;

        if (viewMode)
            return (<div></div>)
        else
            return (
                <a href="#" data-toggle="modal" className="sp-bt-addmore" onClick={() => this.openUploadModal()}>
                    <i className="icon btn-order-savedraft" />
                    <span className="sp-btn-icon-label">แนบเอกสารที่เกี่ยวข้อง</span>
                    {/* <span>Transaction No. : { transaction_no }</span> */}
                </a>
            )
    }
}


export default UploadButton